import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/punto-de-venta/configuraciones/ventas',
  documento: 'pos-settings',
  acceso: 'sesion',
  filas: ['014'],
  cita: 'Areas/POS_Settings/Controllers/SettingsController.cs:102',
} satisfies RutaProd;
